import React from 'react';
import axios from 'axios'
import { useState } from 'react'
import { useEffect } from 'react';
import DataTable from 'react-data-table-component';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import { CSVLink } from "react-csv";
import "../App.css"
import { BarChart, XAxis, YAxis, Tooltip, Bar, ResponsiveContainer, LabelList, Legend } from 'recharts'
import { HiEmojiSad } from 'react-icons/hi';
import { IoFlag, IoFlagOutline } from 'react-icons/io5'
import MoonLoader from "react-spinners/MoonLoader";
import FadeLoader from "react-spinners/FadeLoader";
import UnauthorizedAccess from './UnauthorizedAccess'
import { useForm } from 'react-hook-form';

function CMonitoring({ IP, TOKEN, UserObj }) {


    // useEffect(() => {
    //     fetchFlagList()
    // }, [])

    useEffect(() => {
        fetchFsBatchNames()
    }, [])

    const { register, handleSubmit, formState: { errors } } = useForm()
    const [maxDate, setMaxDate] = useState("");
    const [filteredList, setFilteredList] = useState([])
    const [unAuth, setUnauth] = useState(false)
    const [fsBatchList, setFSBatchList] = useState([])
    const [search, setSearch] = useState("")

    const [fsBatches, setFsBatches] = useState([])
    const [isLoading, setLoading] = useState(false)

    const [attData, setAttData] = useState([])

    const keys = ["htno", "name", "college", "fsname",] // keys for search

    const fetchFsBatchNames = async () => {
        await axios.get(`http://${IP}/fs-batch-names/${TOKEN}/${UserObj.college}`)
            .then(res => {
                setFsBatches(res.data.FSBatches)
            })
            .catch(err => console.log(err))
    }

    useEffect(() => {
        var today = new Date();
        var dd = String(today.getDate()).padStart(2, '0');
        var mm = String(today.getMonth() + 1).padStart(2, '0'); //January is 0!
        var yyyy = today.getFullYear();
        const fulldate = yyyy + "-" + mm + "-" + dd
        setMaxDate(fulldate)
    }, [])


    const fetchFsBatchList = async (formData) => {
        setLoading(true)
        await axios.get(`http://${IP}/fs-students/batchWise/${formData.FsBatch}/${UserObj.college}/${formData.Date}/${TOKEN}`)
            .then(res => {
                if (res.data.msg === "Unauthorized access") {
                    setUnauth(true)
                }
                else {
                    if (res.data.FSBatchList.length !== 0) {
                        setFSBatchList(res.data.FSBatchList);
                        setFilteredList(res.data.FSBatchList);
                        setUnauth(false)
                    }
                    else {
                        setFSBatchList([]);
                        setFilteredList([]);
                    }
                }
                setLoading(false)
            })
            .catch(err => console.log(err))
    }

    useEffect(() => {
        const data = fsBatchList.filter((Obj) => keys.some((key) => { return Obj[key].toLowerCase().includes(search.toLowerCase()) }))
        setFilteredList(data);
    }, [search])


    //export
    const headers = [
        { label: "RollNo", key: "htno" },
        { label: "StudentName", key: "name" },
        { label: "College", key: "college" },
        { label: "Mobile", key: "mobile" },
        { label: "FSBatchName", key: "fsname" },
        { label: "Attendance", key: "attendance" },
        { label: "Att Marked Date", key: "attmarkeddate" }
    ];

    const csvReport = {
        filename: "FS_Students.csv",
        headers: headers,
        data: filteredList
    }

    const columns = [
        // {
        //     name: <span className='flag-btn p-0'><IoFlag /></span>,
        //     selector: (row) => <>
        //         {
        //             flagList.filter(Obj => (Obj.RollNo.toLowerCase()) === (row.RollNo.toLowerCase())).map(filteredData =>
        //                 filteredData.length != 0 && filteredData.flag == 1 ?
        //                     <>
        //                         <input type="hidden" value={filteredData.flag} />
        //                         <button className='flag-btn p-0' onClick={() => setFlag(row.RollNo)}><IoFlag className='text-danger' /></button>
        //                     </>
        //                     :
        //                     <>
        //                         <input type="hidden" value={filteredData.flag} />
        //                         <button className='flag-btn p-0' onClick={() => setFlag(row.RollNo)}><IoFlagOutline /></button>
        //                     </>
        //             )
        //         }</>,
        //     width: "70px",
        //     sortable: true,
        // },
        {
            name: "Roll No.",
            selector: (row) => row.htno,
            // width: "130px",
            sortable: true,
        },
        {
            name: "Student Name",
            selector: (row) => row.name,
            // width: "130px",
            sortable: true,
        },
        {
            name: "College",
            selector: (row) => row.college,
            width: "100px",
            sortable: true,
        },
        {
            name: "Mobile",
            selector: (row) => row.mobile,
            // width: "90px",
            sortable: true,
        },
        {
            name: "FS Batch",
            selector: (row) => row.fsname,
            // width: "110px",
            sortable: true,
        },
        {
            name: "FS Attendance",
            selector: (row) =>
                <>
                    {
                        row.attendance === 1 &&
                        "PRESENT"
                    }
                    {
                        row.attendance === 0 &&
                        <span className='text-danger' style={{ fontWeight: 600 }}>ABSENT</span>
                    }
                    {
                        row.attendance === null &&
                        "N/A"
                    }
                </>
            ,
            // width: "150px",
            sortable: true,
        },
        {
            name: "Time",
            selector: (row) =>
                <>
                    {
                        row.attendance === null ?
                            "N/A"
                            :
                            row.attmarkeddate
                    }
                </>,
            // width: "150px",
            sortable: true,
        },
        // {
        //     name: "FS Performance",
        //     selector: (row) =>
        //         attData.length === 0 ? <>{"fetching..."}</> :
        //             attData.filter(Obj => (Obj.htno.toLowerCase()) === (row.RollNo.toLowerCase())).map(filteredData =>
        //                 filteredData.ppercentile
        //             ),
        //     width: "150px",
        //     sortable: true,
        // },
        // {
        //     name: "Flagged On",
        //     selector: (row) => flagList.filter(Obj => (Obj.RollNo.toLowerCase()) === (row.RollNo.toLowerCase())).map(filteredData =>
        //         filteredData.flaggedOn
        //     ),
        //     width: "170px",
        //     sortable: true
        // },
        // {
        //     name: "Flag released On",
        //     selector: (row) => flagList.filter(Obj => (Obj.RollNo.toLowerCase()) === (row.RollNo.toLowerCase())).map(filteredData =>
        //         filteredData.flagReleasedOn
        //     ),
        //     width: "170px",
        //     sortable: true
        // },
        // {
        //     name: "Project Title",
        //     selector: (row) => row.projectTitle,
        //     width: "360px",
        //     sortable: true,
        // }
    ]

    const [show, setShow] = useState(false);
    const [rowData, setRowData] = useState({})
    const [chartLoading, setChartLoading] = useState(false)
    const [dayWiswAtt, setDayWiseAtt] = useState([]);
    const [dayWiswPerformance, setDayWisePerformance] = useState([]);

    const handleSelectedRow = async (data) => {
        setShow(true)
        setChartLoading(true)
        let x = fsBatchList.filter(Obj => (Obj.RollNo.toLowerCase()) === (data.RollNo.toLowerCase()))
        let y = attData.filter(Obj => (Obj.htno.toLowerCase()) === (data.RollNo.toLowerCase()))
        if (y.length === 0) {
            data = { ...data, StudentName: x[0].StudentName, Section: x[0].Section }
        }
        else {
            data = { ...data, StudentName: x[0].StudentName, Section: x[0].Section, apercentile: y[0].apercentile, ppercentile: y[0].ppercentile }
        }

        await axios.post(`http://${IP}/getdaywiseatt${data.RollNo}`)
            .then(response => {
                setDayWiseAtt(response.data.daywiseatt)
            })
        await axios.post(`http://${IP}/getdaywiseperformance${data.RollNo}`)
            .then(response => {
                setDayWisePerformance(response.data.daywiseperformance)
            })
        setRowData(data)
        setChartLoading(false)
    }

    const handleClose = () => {
        setShow(false);
        setChartLoading(false)
    }

    const CustomAttendanceTooltip = ({ active, payload }) => {
        if (active && payload && payload.length && (payload[0].value == 1)) {
            return (
                <div className="custom-tooltip bg-white p-2 pb-0" style={{ border: "1px solid #012951" }}>
                    <p className="label" style={{ fontSize: "12px" }}>{`Session: ${payload[0].payload.session} `}</p>
                    <p className="label" style={{ fontSize: "12px" }}>{"Attendance : Present"}</p>

                </div>
            );
        }
        if (active && payload && payload.length && (payload[0].value == 0)) {
            return (
                <div className="custom-tooltip bg-white p-2 pb-0" style={{ border: "1px solid #012951" }}>
                    <p className="label" style={{ fontSize: "12px" }}>{`Session : ${payload[0].payload.session} `}</p>
                    <p className="label" style={{ fontSize: "12px" }}>{"Attendance : Absent"}</p>
                </div>
            );
        }
        return null;
    }

    const CustomPerformanceTooltip = ({ active, payload }) => {
        if (active && payload && payload.length) {
            return (
                <div className="custom-tooltip bg-white p-2 pb-0" style={{ border: "1px solid #012951" }}>
                    <p className="label" style={{ fontSize: "12px" }}>{`Session : ${payload[0].payload.session} `}</p>
                    <p className="label" style={{ fontSize: "12px" }}>{`Grade : ${payload[0].payload.grade} /${payload[0].payload.totalgrade}`}</p >
                </div >
            );
        }
        return null;
    }

    const formatYAxis = (value) => {
        if (value === 0) return "Absent"
        if (value === 1) return "Present"
        return value
    }

    return (
        <div className='container-fluid'>
            <Modal show={show} onHide={handleClose} centered size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>
                        {
                            chartLoading === false &&
                            <div className='text-start'>
                                <h5 className='mb-2'>Coding School Performance</h5>
                                <span className='text-muted' style={{ fontSize: "15px" }}>Attendance &amp; Performance of </span>
                                <h6 className='d-inline'>{rowData.RollNo}, {rowData.StudentName}, {rowData.Section}</h6>
                            </div>
                        }
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {
                        // let y = attData.filter(Obj => (Obj.htno.toLowerCase()) === (data.RollNo.toLowerCase()))
                        chartLoading === true ?
                            <div>
                                <FadeLoader
                                    className='mx-auto'
                                    color="#012951"
                                    loading={chartLoading}
                                />
                                <h6 className='text-center p-3'>Fetching data please wait...</h6>
                            </div>
                            :
                            <div>
                                {/* <div className='d-lg-flex d-md-flex'>
                                    <div className='me-3'><span className='text-muted me-1'>Overall Attendance (%) : </span><span>{rowData.apercentile}%</span></div>
                                    <div><span className='text-muted me-1'>Overall Performance (%) : </span><span>{rowData.ppercentile}%</span></div>
                                </div> */}
                                {
                                    dayWiswAtt.length === 0 ?
                                        <h6 className='text-center text-danger mt-4 mb-2'>Attendance not found</h6> :
                                        <div style={{ width: "100%", height: 150 }} >
                                            <div className='d-flex justify-content-between'>
                                                <h6 className='mt-1'>Attendance : Last {dayWiswAtt.length} days</h6>
                                                <div className='me-3'><span className='text-muted me-1'>Overall (%) : </span><h6 className='d-inline'>{rowData.apercentile}%</h6></div>
                                            </div>
                                            <ResponsiveContainer>
                                                <BarChart className="m-0" data={dayWiswAtt} margin={{ top: 15, bottom: 25 }}>
                                                    <XAxis dataKey="label" fontSize={12} />
                                                    <YAxis tickCount={2} fontSize={12} />
                                                    <Tooltip content={<CustomAttendanceTooltip />} />
                                                    <Legend
                                                        payload={
                                                            [
                                                                { id: 'label', value: "Present", type: 'rect', color: '#012951', fontSize: '12px' },
                                                                { id: 'label', value: 'Absent', type: 'rect', color: '#c4c2c2' },
                                                            ]
                                                        }
                                                    />
                                                    <Bar dataKey="attendance" barSize={25} fill="#012951" background={{ fill: '#c4c2c0' }} />
                                                </BarChart>
                                            </ResponsiveContainer>
                                        </div>
                                }
                                <hr />
                                {
                                    dayWiswPerformance.length === 0 ?
                                        <h6 className='text-center text-danger mt-4 mb-2'>Performance not found</h6> :
                                        <div style={{ width: "100%", height: 200 }}>
                                            <div className='d-flex justify-content-between'>
                                                <h6 className='mt-3'>Performance : Last {dayWiswPerformance.length} days</h6>
                                                <div className='me-3'><span className='text-muted me-1'>Overall (%) : </span><h6 className='d-inline'>{rowData.ppercentile}%</h6></div>
                                            </div>
                                            <ResponsiveContainer>
                                                <BarChart className="m-0" data={dayWiswPerformance} margin={{ top: 20, bottom: 35 }}>
                                                    <XAxis dataKey="label" fontSize={12} />
                                                    <YAxis tickCount={4} fontSize={12} />
                                                    <Tooltip content={<CustomPerformanceTooltip />} />
                                                    <Legend
                                                        payload={
                                                            [
                                                                { id: 'label', value: "TotalGrade", type: 'rect', color: '#012951' },
                                                                { id: 'label', value: 'SecuredGrade', type: 'rect', color: '#f78716' },
                                                            ]
                                                        }
                                                    />
                                                    <Bar dataKey="totalgrade" barSize={30} fill="#012951" background={{ fill: '#c4c2c2' }} >
                                                        <LabelList dataKey="totalgrade" position="top" fontSize={11} />
                                                    </Bar>
                                                    <Bar dataKey="grade" barSize={30} fill="#f78716" background={{ fill: '#c4c2c0' }} >
                                                        <LabelList dataKey="grade" position="top" fontSize={11} />
                                                    </Bar>
                                                </BarChart>
                                            </ResponsiveContainer>
                                        </div>
                                }
                            </div>
                    }
                </Modal.Body>
            </Modal>
            <div className='m-auto' style={{ maxWidth: "1300px" }}>
                <h6 className='mt-3 pt-2'>Filter By</h6>
                <form className='mb-4 mt-2 p-0' onSubmit={handleSubmit(fetchFsBatchList)}>
                    <div className='row'>
                        <div className="form-group mt-1 col-lg-2 col-md-4 col-sm-4 col-4 ">
                            <label htmlFor='fsbatch' className='me-2'><small>FS Batch</small></label>
                            <select className='form-select form-select-sm' id="fsbatch" {...register("FsBatch", { required: true })}>
                                <option defaultChecked value="">Select FS Batch...</option>
                                {
                                    fsBatches.map(obj => <option value={obj.id} key={obj.id}>{obj.name}</option>)
                                }
                            </select>
                            {errors.FsBatch && <span className='text-danger'>Fs Batch is required</span>}
                        </div>
                        <div className="form-group mt-1 col-lg-2 col-md-4 col-sm-4 col-4 ">
                            <label htmlFor='date' className='me-2'><small>Select date</small></label>
                            <input type="date" id="date" className="form-control form-control-sm" min="2022-11-28" max={maxDate} {...register("Date", { required: true })} />
                            {errors.Date && <span className='text-danger'>Date is required</span>}
                        </div>
                        {/* <div className="form-group mt-1 col-lg-2 col-md-4 col-sm-4 col-4 ">
                            <label htmlFor='college' className='me-2'><small>College</small></label>
                            <select className='form-select form-select-sm' id="college" {...register("College", { required: true })}>
                                <option defaultChecked value="">Select college...</option>
                                <option value="all">KMIT & NGIT</option>
                                <option value="KMIT">KMIT</option>
                                <option value="NGIT">NGIT</option>
                            </select>
                            {errors.College && <span className='text-danger'>College is required</span>}
                        </div> */}
                        <div className='form-group mt-1 col-lg-2 col-md-4 col-sm-4 col-4'>
                            <label htmlFor='fsdate' className='me-2'></label><br />
                            <button className='btn btn-sm btn-primary'>Get Details</button>
                        </div>
                    </div>
                </form>
            </div>
            {
                isLoading == true ? (
                    <div>
                        {/* <div className="loader">Loading...</div> */}
                        <h3 className='text-center mt-4'>Loading please wait...</h3>
                        <MoonLoader
                            className='mx-auto moonloader'
                            color="#012951"
                            loading={isLoading}
                            speedMultiplier={1}
                        />
                    </div>
                ) :
                    unAuth === true ?
                        <div>
                            <UnauthorizedAccess />
                        </div>
                        :
                        fsBatchList.length === 0 ?
                            <h5 className='text-center mt-5'><HiEmojiSad /> Oops... No Data Found </h5> :
                            <div className='mt-2 data-table-manage-projects'>
                                {/* <nav>
                                <small>
                                    <ol className="breadcrumb">
                                        <li className="breadcrumb-item active d-inline">Showing results of -&gt; {selectedPSY}</li>
                                        {
                                            selectedCollege != "" &&
                                            <li className="breadcrumb-item active d-inline">{selectedCollege.toLowerCase()}</li>
                                        }
                                        {
                                            selectedStdyr != "" &&
                                            <li className="breadcrumb-item active d-inline">{selectedStdyr}year</li>
                                        }
                                        {
                                            selectedDay != "" &&
                                            <li className="breadcrumb-item active d-inline">{selectedDay.toLowerCase()}</li>
                                        }
                                        {
                                            selectedProject != "" &&
                                            <li className="breadcrumb-item active d-inline">{selectedProject.toLowerCase()}</li>
                                        }
                                        {
                                            selectedGroup != "" &&
                                            <li className="breadcrumb-item active d-inline">{selectedGroup.toLowerCase()}</li>
                                        }
                                    </ol>
                                </small>
                            </nav> */}

                                <DataTable
                                    columns={columns}
                                    data={filteredList}
                                    // onRowClicked={handleSelectedRow}
                                    // selectableRows
                                    // selectableRowsHighlight
                                    // onSelectedRowsChange={rowsSelected}
                                    // defaultSortFieldId={7}
                                    pointerOnHover
                                    pagination
                                    paginationPerPage={25}
                                    paginationRowsPerPageOptions={[25, 50, 75, 100, 150]}
                                    fixedHeader
                                    fixedHeaderScrollHeight='600px'
                                    highlightOnHover
                                    actions={<CSVLink {...csvReport}><button className='btn btn-sm btn-primary m-0'>Export</button></CSVLink>}
                                    subHeader
                                    subHeaderComponent={
                                        <>
                                            <input type="text" className='form-control form-control-sm datatable-search' placeholder='Search here...' value={search} onChange={(e) => setSearch(e.target.value)} />
                                        </>
                                    }
                                />
                            </div>
            }
        </div >
    )
}

export default CMonitoring